// https://stackoverflow.com/a/57047786
export function isRelativeLink(link: string): boolean {
    return new URL(document.URL).origin === new URL(link, document.URL).origin;
}
